import useTranslations from "@/shared/lang/useTranslations";

import { PayinRail } from "../services/paymentsPayin.service";
import { RuntimeDepositPanel } from "./RuntimeDepositPanel";

/**
 * Argentina deposit panel — the ONLY way into the ARS corridor.
 *
 * The organization has a standing receiving CVU: anyone transfers in ARS from a bank (CBU) or a wallet (CVU)
 * for any amount, and the provider webhook attributes and credits the deposit.
 *
 * Unlike México, Argentina genuinely cannot be initiated. `InitiatePayinDto` does accept the rail — the
 * earlier comment here was wrong about that — but `BitsoPaymentProvider.initiatePayin` throws `does not
 * support CBU_CVU payins` on the switch default, and `PayinService.payerToOrigin` has no CBU_CVU branch
 * either (it falls through to the PIX snapshot). So there is no charge to create, and the simulator is on:
 * pricing has no form to live in.
 */
export function ArgentinaDepositPanel() {
  const { t } = useTranslations("payins");

  return (
    <RuntimeDepositPanel
      country="ARG"
      rail={PayinRail.CBU_CVU}
      currency="ARS"
      showSimulator
      texts={{
        instructionsTitle: t("arg_panel_instructions_title"),
        instructionsBody: t("arg_panel_instructions_body"),
        accountHint: t("arg_panel_cvu_hint"),
        depositsTitle: t("arg_panel_deposits_title"),
        depositsEmpty: t("arg_panel_deposits_empty"),
        refreshAria: t("arg_panel_refresh_aria"),
        statusProcessing: t("arg_panel_status_processing"),
        statusCredited: t("arg_panel_status_credited"),
        statusFailed: t("arg_panel_status_failed"),
      }}
    />
  );
}
